import { useApi } from '@backstage/core-plugin-api';
import { uptimeMonitorApiRef } from '../api/UptimeMonitorApi';
import { useAsyncFn } from 'react-use';
import { useCallback } from 'react';
import { AISuggestionResponse, GenerateAISuggestionRequest } from '../types';

export const useGenerateAISuggestion = () => {
  const api = useApi(uptimeMonitorApiRef);

  const [state, generateSuggestion] = useAsyncFn(async (params: GenerateAISuggestionRequest): Promise<AISuggestionResponse> => {
    try {
      const result = await api.generateAISuggestion(params);
      return result;
    } catch (err: any) {
      console.error('Error generating AI suggestion:', err);
      throw err;
    }
  }, [api]);

  const generate = useCallback(
    (prompt: string, eventId: string, model?: string) => {
      const params: GenerateAISuggestionRequest = {
        prompt,
        data_id: eventId,
        model: model || 'gemini-2.5-flash',
      };
      return generateSuggestion(params);
    },
    [generateSuggestion],
  );

  return {
    isGenerating: state.loading,
    generatedSuggestion: state.value,
    error: state.error,
    generate,
  };
};